/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useSelector } from 'react-redux';
import axios from 'axios';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import moment from 'moment';
import { RadioGroupComponent } from '../../Claim/component/SelectClaim/SelectClaimSearchComponent';
import CalculatedInterestDetailsTable from './CalculatedInterestDetailsTable';
import CalculatedInterestPagination from './CalculatedInterestPagination';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import CalculatedInterestDetailsQuarterTable from './CalculatedInterestDetailsQuarterTable';
import { NO_VALUE_RESPOSNE_INTEREST } from '../../../../SharedModules/Errors/constantMessageData';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { handleCommaSeparatedAmount } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const CalculatedInterestDetails = () => {
  const DETAILS_BY_OPTIONS = [
    { name: 'NDC', value: 'NDC' },
    { name: 'Quarter', value: 'QUARTER' },
  ];
  const [selectType, setSelectType] = useState('NDC');
  const [interestDetails, setInterestDetail] = useState({});
  const [drugDetail, setDrugDetail] = useState();
  const [drugDetails, setDrugDetails] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [currentDrugIndex, setCurrentDrugIndex] = useState(1);
  const [qtrData, setQtrData] = useState([]);
  const [ndcGridData, setNdcGridData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [fullScreenView, setFullScreenView] = useState(false);
  const { calculatedInterestDetails, calculatedInterestPayload } = useSelector(
    (state) => state?.sharedState?.CalculatedInterestReducer
  );
 const searchScreenTabRedux = useSelector((state) => {
    return state.sharedState?.CalculatedInterestReducer?.calculatedInterestDetails[0];
  });
   
const { calculateduserInputs = {} } = useSelector(
      (state) => state?.sharedState?.CalculatedInterestReducer || {}
  );
  useEffect(() => {
    setDetailsByNDC();
  }, [calculatedInterestDetails, currentIndex]);

  useEffect(() => {
    if (selectType === 'QUARTER' && qtrData?.length === 0) {
      setOpenModal(true);
    }
  }, [qtrData]);    

  useEffect(() => {
    if (drugDetails?.length > 0 && currentDrugIndex > 0) {
      setDrugDetail(drugDetails[currentDrugIndex - 1]);
      const drugQtrDetails = drugDetails[currentDrugIndex - 1]?.drugQtrDetails;
      const qtrGridDataTemp = getQtrDetailsGridData(drugQtrDetails);

      setNdcGridData(qtrGridDataTemp);
    }
  }, [currentDrugIndex, drugDetails]);

  useEffect(() => {
    if (selectType === 'QUARTER') {
      getDetaildByQuarter(selectType);
    } else if (selectType === 'NDC') {
      setDetailsByNDC();
    }
  }, [selectType]);

  useEffect(() => {
    if (selectType === 'QUARTER') {
      getDetaildByQuarter(selectType);
    }
  }, [interestDetails]);

  const getDrugInterest = () => {
    return drugDetail?.totalInterest
      ? `${
          drugDetail?.totalInterest
            ? handleCommaSeparatedAmount(drugDetail?.totalInterest) // .toFixed(2)
            : '0.00'
        }`
      : '';
  };
  const getQtrDetailsGridData = (drugQtrDetails) => {
    const qtrGridDataTemp = [];
    if (drugQtrDetails && drugQtrDetails?.length > 0) {
      drugQtrDetails.forEach((item) => {
        const tempMap = {
          qtr: item.drugQtrDetailsId?.qtr,
          principalDue: item.principalAmt,
          preIntrest: item.prevInterestAmt,
          newInt: item.newInterestAmt,
          totalInt: item.totalInterestAmt,
          totalDue: item.totalDueAmt,
          drugQtrDetailsId: item.drugQtrDetailsId,
        };
        qtrGridDataTemp.push(tempMap);
      });
      return qtrGridDataTemp;
    }
  };
  const getDrugNDC = () => {
    const lbCode = drugDetail?.labelerCode
      ? drugDetail.labelerCode.toString()
      : '';

    const pc = drugDetail?.productCode ? `-${drugDetail.productCode}` : '';

    const ps = drugDetail?.packageSize ? `-${drugDetail.packageSize}` : '';

    return `${lbCode}${pc}${ps}`;
  };
  const getDetaildByQuarter = async (detailsBy) => {
    let payload = {};
    if (calculatedInterestPayload?.chooseBy === 'NDC') {
      payload = {
        startQtr: calculatedInterestPayload.startQtr
          ? calculatedInterestPayload.startQtr
          : '',
        rebateProgramCd: calculatedInterestPayload?.rebateProgramCd,
        planTypeCd: calculatedInterestPayload?.planTypeCd,
        endQtr: calculatedInterestPayload.endQtr
          ? calculatedInterestPayload.endQtr
          : '',
        allQtrs: true,
        mfgId: calculatedInterestPayload.mfgId
          ? calculatedInterestPayload.mfgId
          : [],
        chooseBy: 'Ndc',
        drugSeqNumList: calculatedInterestPayload?.drugSeqNumList,
        detailsBy: 'Ndc',
        labelerVO: { labelerCode: interestDetails?.labelerCode },
      };
    } else if (calculatedInterestPayload?.chooseBy === 'mfg') {
      payload = {
        startQtr: calculatedInterestPayload.startQtr
          ? calculatedInterestPayload.startQtr
          : '',
        rebateProgramCd: calculatedInterestPayload?.rebateProgramCd,
        planTypeCd: calculatedInterestPayload?.planTypeCd,
        endQtr: calculatedInterestPayload.endQtr
          ? calculatedInterestPayload.endQtr
          : '',
        allQtrs: true,
        mfgId: calculatedInterestPayload.mfgId
          ? calculatedInterestPayload.mfgId
          : [],
        chooseBy: 'mfg',
        drugSeqNumList: [],
        detailsBy: 'mfg',
        labelerVO: { labelerCode: interestDetails?.labelerCode },
      };
    }
    if (detailsBy === 'Quarter' || detailsBy === 'QUARTER') {
      payload = {
        allQtrs: calculateduserInputs.allQtr==true?true:false,
        detailsBy: calculatedInterestPayload?.chooseBy,
        drugSeqNumList: calculatedInterestPayload?.drugSeqNumList,
        startQtr: calculatedInterestPayload.startQtr
          ? calculatedInterestPayload.startQtr
          : '',
        rebateProgramCd: calculatedInterestPayload?.rebateProgramCd,
        planTypeCd: calculatedInterestPayload?.planTypeCd,
        endQtr: calculatedInterestPayload.endQtr
          ? calculatedInterestPayload.endQtr
          : '',
        labelerCode: interestDetails?.labelerCode,
        labelerVO: { labelerCode: interestDetails?.labelerCode },
      };
    }

    try {
      const response = await axios.post(
        `${serviceEndPoint.VIEW_CALCULATED_INTEREST_QUARTER_DETAILS}`,
        payload
      );
      if (response?.status === 200) {
        setQtrData(response?.data);
      }
      if (response?.data?.status === 500) {
        // setErrorMessages([response?.data?.data]);
      }
    } catch (err) {}
  };
  const setDetailsByNDC = () => {
    if (calculatedInterestDetails) {
      setInterestDetail({
        ...calculatedInterestDetails[currentIndex - 1],
       asOfDate: searchScreenTabRedux?.asOfDate
          ? moment(searchScreenTabRedux?.asOfDate).format('MM/DD/yyyy')
          : '',
      });
      if (
        calculatedInterestDetails[currentIndex - 1]?.drugs &&
        calculatedInterestDetails[currentIndex - 1]?.drugs?.length > 0
      ) {
        setDrugDetails(
          calculatedInterestDetails[currentIndex - 1]?.drugs || []
        );
        setDrugDetail(calculatedInterestDetails[currentIndex - 1]?.drugs[0]);
        if (calculatedInterestDetails[currentIndex - 1]?.drugs?.length > 0) {
          setCurrentDrugIndex(1);
          const qtrGridDataTemp = getQtrDetailsGridData(
            calculatedInterestDetails[currentIndex - 1]?.drugs[0]
              ?.drugQtrDetails
          );
          setNdcGridData(qtrGridDataTemp);
        } else {
          setNdcGridData([]);
          setCurrentDrugIndex(0);
          setDrugDetails([]);
          setDrugDetail({ ndc: '', drugName: '', totalInterest: '' });
        }
      } else {
        setDrugDetails([]);
        setDrugDetail({ ndc: '', drugName: '', totalInterest: '' });
        setOpenModal(true);
        setCurrentDrugIndex(0);
        setNdcGridData([]);
      }
    }
  };
const totalInterestSum = drugDetails.reduce((sum, item) => {
  return sum + (item.totalInterest || 0);
}, 0);

  return (
    <div className="tabs-container calculated-interest-details">
      <CustomSeparator
        parent1="Display"
        parent2="View Calculated Interest Details"
      />
      {!fullScreenView && (
        <>
          <div className="tBillPanel custom-check">
            <div className="panel tBillPanel-space pb-0">
              <div className="panel mb-3">
                <div className="row">
                  <div
                    className="row float-right mr-3"
                    style={{ marginLeft: '80%' }}
                  >
                    <CalculatedInterestPagination
                      paginationIndex={currentIndex}
                      setPaginationIndex={setCurrentIndex}
                      maxPages={calculatedInterestDetails?.length}
                    />
                  </div>
                  <div className="col-12">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">Labeler</legend>
                      <div className="row">
                        <div className="col-sm-2 mt-2">
                          <div className="form-wrapper p-0 mt-2">
                            <div className="mui-custom-form input-md field-xl">
                              <div>
                                <TextField
                                  label="Labeler"
                                  fullWidth
                                  placeholder=""
                                  InputLabelProps={{
                                    shrink: true,
                                    color: '#274463',
                                  }}
                                  id="labeler"
                                  name="labeler"
                                  value={interestDetails?.labelerCode}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4 mt-2">
                          <div className="form-wrapper p-0 mt-2">
                            <div className="mui-custom-form input-md field-xl">
                              <div>
                                <label
                                  className="m-0 hide-elm"
                                  htmlFor="labeler_empty"
                                >
                                  <span>label</span>{' '}
                                </label>
                                {interestDetails?.labelerName?.length > 24 ? (
                                  <OverlayTrigger
                                    placement="bottom"
                                    overlay={
                                      <Tooltip id="com-tooltip">
                                        {interestDetails?.labelerName}
                                      </Tooltip>
                                    }
                                  >
                                    <TextField
                                      label=""
                                      fullWidth
                                      placeholder=""
                                      InputLabelProps={{
                                        shrink: true,
                                        color: '#274463',
                                      }}
                                      name="labeler"
                                      id="labeler"
                                      inputProps={{ id: 'labeler' }}
                                      value={`${interestDetails?.labelerName.substring(
                                        0,
                                        24
                                      )} ...`}
                                      disabled
                                    />
                                  </OverlayTrigger>
                                ) : (
                                  <TextField
                                    label=""
                                    fullWidth
                                    placeholder=""
                                    name="labeler"
                                    InputLabelProps={{
                                      shrink: true,
                                      color: '#274463',
                                    }}
                                    id="labeler"
                                    inputProps={{ id: 'labeler' }}
                                    value={interestDetails?.labelerName}
                                    disabled
                                  />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-2 mt-2">
                          <div className="form-wrapper p-0 mt-2">
                            <div className="mui-custom-form input-md field-xl">
                              <div>
                                <TextField
                                  label="As of Date"
                                  fullWidth
                                  placeholder=""
                                  InputLabelProps={{
                                    shrink: true,
                                    color: '#274463',
                                  }}
                                  id="asofdate"
                                  name="asofdate"
                                  value={drugDetail?.asOfDate}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-4 mt-2">
                          <div className="form-wrapper p-0 mt-2">
                            <div className="mui-custom-form input-md field-xl">
                              <div>
                                <TextField
                                  label="Total Interest"
                                  fullWidth
                                  placeholder=""
                                  InputLabelProps={{
                                    shrink: true,
                                    color: '#274463',
                                  }}
                                  id="interest"
                                  name="interest"
                                  value={` ${
                                    isNaN(
                                      totalInterestSum
                                    )
                                      ? '$ 0.00'
                                      : handleCommaSeparatedAmount(
                                          totalInterestSum
                                        )
                                  }`}
                                  disabled
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4 mt-2">
                    <fieldset className="custom-fieldset">
                      <legend className="same-font-family">Details By</legend>
                      <div className="p-0 mt-2 row">
                        <div className="mui-custom-form col-12 m-0">
                          <RadioGroupComponent
                            data={DETAILS_BY_OPTIONS}
                            value={selectType}
                            onChange={(_, value) => {
                              // setErrorMessages([]);
                              setSelectType(value);
                            }}
                          />
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  {selectType === 'NDC' && (
                    <div className="col-8 mt-2">
                      <fieldset className="custom-fieldset">
                        <legend className="same-font-family">Drug</legend>
                        <div className="row">
                          <div className="col-sm-4 mt-2">
                            <div className="form-wrapper p-0 mt-2">
                              <div className="mui-custom-form input-md field-xl">
                                <div>
                                  <TextField
                                    label="NDC"
                                    fullWidth
                                    placeholder=""
                                    InputLabelProps={{
                                      shrink: true,
                                      color: '#274463',
                                    }}
                                    id="drugNDC"
                                    name="drugNDC"
                                    value={getDrugNDC()}
                                    disabled
                                    style={{ textAlign: 'left !important' }}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 mt-2">
                            <div className="form-wrapper p-0 mt-2">
                              <div className="mui-custom-form input-md field-xl">
                                <div>
                                  {drugDetail?.drugName?.length > 18 ? (
                                    <OverlayTrigger
                                      placement="bottom"
                                      overlay={
                                        <Tooltip id="com-tooltip">
                                          {drugDetail?.drugName}
                                        </Tooltip>
                                      }
                                    >
                                      <TextField
                                        label="Drug Name"
                                        fullWidth
                                        placeholder=""
                                        InputLabelProps={{
                                          shrink: true,
                                          color: '#274463',
                                        }}
                                        id="drug_name"
                                        name="labeler"
                                        value={`${drugDetail?.drugName.substring(
                                          0,
                                          18
                                        )} ...`}
                                        disabled
                                      />
                                    </OverlayTrigger>
                                  ) : (
                                    <TextField
                                      label="Drug Name"
                                      fullWidth
                                      placeholder=""
                                      InputLabelProps={{
                                        shrink: true,
                                        color: '#274463',
                                      }}
                                      id="drug_name"
                                      name="labeler"
                                      value={drugDetail?.drugName}
                                      disabled
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-4 mt-2">
                            <div className="form-wrapper p-0 mt-2">
                              <div className="mui-custom-form input-md field-xl">
                                <div>
                                  <TextField
                                    label="Total Drug Interest"
                                    fullWidth
                                    placeholder=""
                                    InputLabelProps={{
                                      shrink: true,
                                      color: '#274463',
                                    }}
                                    id="total_drug_interest"
                                    name="asofdate"
                                    value={getDrugInterest()}
                                    disabled
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {drugDetails && (
                          <div className="row float-right mr-3">
                            <CalculatedInterestPagination
                              paginationIndex={currentDrugIndex}
                              setPaginationIndex={setCurrentDrugIndex}
                              maxPages={drugDetails?.length}
                            />
                          </div>
                        )}
                      </fieldset>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {selectType === 'NDC' && ndcGridData?.length > 0 ? (
        <div className="row">
          <div className="col-12 p-0">
            <CalculatedInterestDetailsTable
              reportData={ndcGridData}
              fullScreen={fullScreenView}
              setFullScreen={setFullScreenView}
              ndcpagination={currentDrugIndex}
            />
          </div>
        </div>
      ) : null}
      {selectType === 'QUARTER' && qtrData?.length > 0 ? (
        <div className="row">
          <div className="col-12 p-0">
            <CalculatedInterestDetailsQuarterTable
              reportData={qtrData}
              fullScreen={fullScreenView}
              setFullScreen={setFullScreenView}
            />
          </div>
        </div>
      ) : null}
      <CommonModal
        open={openModal}
        viewAction
        viewHeader
        className="frr-rightAlignment"
        onOk={() => {
          setOpenModal(false);
        }}
        okTitle="OK"
        onClose={() => setOpenModal(false)}
        closeTitle="Cancel"
        modalTitle="View Calculated Interest"
        childrenComponent={
          <div className="p-3">{NO_VALUE_RESPOSNE_INTEREST}</div>
        }
      />
    </div>
  );
};
export default CalculatedInterestDetails;
